import { Trans } from "react-i18next";

import util from "utils/utils";

import FormattedComment from "components/lib/FormattedComment";

import type { NotificationContentProps } from "../../types";

export default function IdeaCommentReply({
  events = [],
  ownerIdea,
  ownerChallenge,
  ownerGroup,
  status,
}: NotificationContentProps) {
  return (
    <Trans
      i18nKey="notifications.ideaCommentReplied"
      values={{
        name: util.getEventNames(events ?? []),
        idea: ownerIdea?.name || "Deleted",
        comment: events[0]?.comment || "",
      }}
      components={{
        b: <b />,
        formattedComment: <FormattedComment noLink maxLength={100} />,
      }}
    />
  );
}
